import { render } from "./ProductRankingsCard.vue?vue&type=template&id=5e4f04bd&scoped=true"
import script from "./ProductRankingsCard.vue?vue&type=script&lang=js"
export * from "./ProductRankingsCard.vue?vue&type=script&lang=js"

import "./ProductRankingsCard.vue?vue&type=style&index=0&id=5e4f04bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4f04bd"]])

export default __exports__